// @mui material components
import { Snackbar, Alert, Card, CircularProgress, Backdrop, Icon } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
// import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
// import MDBadge from "theme/components/MDBadge";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";
import { useAuthUser } from "react-auth-kit";
import AppConfig from "appConfig";

// import Editor from "react-simple-wysiwyg";

function AccountSales() {
  const pageTitle = "Sales";
  usePageTitle(pageTitle);

  const auth = useAuthUser();
  const accountInfo = auth();

  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [orders, setOrders] = useState([]);
  const [currency, setCurrency] = useState("");
  const [pageLoaded, setPageLoaded] = useState(false);

  const tableColumns = [
    { Header: "#", accessor: "order", align: "center" },
    { Header: "Campaign", accessor: "campaign", align: "left" },
    { Header: "Customer", accessor: "customer", align: "left" },
    { Header: "Agent", accessor: "agent", align: "left" },
    { Header: "Group", accessor: "agent_group", align: "left" },
    { Header: "Supervisor", accessor: "aggregator", align: "left" },
    { Header: "Amount", accessor: "amount", align: "left" },
    { Header: "Method", accessor: "payment_method", align: "left" },
    { Header: "Date", accessor: "created", align: "center" },
  ];

  const buildRateRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        order: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="contained"
              color="info"
              iconOnly
              circular
              onClick={() => {
                navigate(`/campaigns-orders/${row.reference}`);
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                visibility
              </Icon>
            </MDButton>
          </MDBox>
        ),
        campaign: row.campaign,
        customer: row.customer,
        amount: `${currency}${(row.amount / 100).toLocaleString("en", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        payment_method: row.payment_method,
        agent: row.agent,
        agent_group: row.agent_group ? row.agent_group : "---",
        aggregator: row.aggregator ? row.aggregator : "---",
        location: (
          <a
            rel="noreferrer"
            target="_blank"
            href={`https://maps.google.com?q=${row.latitude},${row.longitude}`}
          >
            <Icon>location_on</Icon>
          </a>
        ),
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/orders.json`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            const rows = buildRateRows(result.data.data.orders);
            setOrders(rows);

            setCurrency(result.data.data.currency);
            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      <MDBox pt={3} pb={3}>
        {pageLoaded && (
          <MDBox>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox p={1}>
                <MDBox
                  pt={2}
                  px={2}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <MDTypography variant="h6" fontWeight="medium">
                    Sales
                  </MDTypography>
                  <MDTypography variant="h6" fontWeight="light" align="right">
                    <MDButton
                      color="dark"
                      variant="outlined"
                      size="small"
                      startIcon={<Icon sx={{ fontWeight: "bold" }}>download</Icon>}
                      onClick={() => {
                        const downloadUrl = `${AppConfig.api_base_url}accounts/reports/${accountInfo.account.reference}`;
                        window.open(downloadUrl, "_blank");
                      }}
                    >
                      Download
                    </MDButton>
                  </MDTypography>
                </MDBox>
                <MDBox mt={5}>
                  <DataTable
                    table={{ columns: tableColumns, rows: orders }}
                    isSorted
                    entriesPerPage
                    showTotalEntries
                    buttons
                    noEndBorder
                  />
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AccountSales;
